
export default {
  name: 'PanelItem',
};
